export function GradientOrbs() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <div className="absolute w-[400px] h-[400px] rounded-full bg-emerald-500/20 blur-3xl animate-orb-1 -top-32 -left-32" />
      <div className="absolute w-[350px] h-[350px] rounded-full bg-teal-400/15 blur-3xl animate-orb-2 top-1/2 -right-24" />
      <div className="absolute w-[500px] h-[500px] rounded-full bg-cyan-500/10 blur-3xl animate-orb-3 -bottom-48 left-1/3" />
    </div>
  );
}
